import { inject, Injectable } from '@angular/core';
import {
  IUADeletionPayload,
  IUASearchObj,
  IUASearchResponse,
  UserActivity,
  UserActivityEndpointBase,
} from './user-activity.model';
import { ApiService } from '../../../services/api.service';
import { ISearchResponse2, UserActivityService } from 'ets-fe-ng-sdk';
import { of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Store } from '@ngrx/store';
import { AuthStore } from '../../../@ngrx/auth/auth.reducer';

@Injectable({
  providedIn: 'root',
})
export class UserActivityEndpointService {
  private baseURL = UserActivityEndpointBase;
  protected readonly store = inject(Store);
  readonly userType = this.store.selectSignal(AuthStore.Selectors.userType);
  constructor(
    private apiService: ApiService,
    service: UserActivityService,
  ) {
    // debugger;
    // console.log('service.submissionFunc');
    service.submissionFunc = this.submitUA;
    // service.add({ code: '' });
  }
  submitUA = (uas: UserActivity[]) => {
    try {
      if (!environment.token) {
        throw `no auth`;
      }
      if (!environment.production && !environment.logActivities) throw `logging not allowed`;
      const _uas: UserActivity[] = [];
      for (const x of uas || []) {
        x.screen = x.screen || x['code'];
        if (!x.screen || !x?.screen?.length) continue;
        x.userType = x.userType || this.userType();
        _uas.push(x);
      }

      return _uas.length ? this.apiService.post(this.baseURL, _uas) : of([]);
    } catch (error) {
      console.warn(error);
      return of(null);
    }
  };
  clear = (uas: IUADeletionPayload[]) => {
    return this.apiService.deleteWithBody(`${this.baseURL}/clear`, uas);
  };
  search = (query?: IUASearchObj) => {
    if (query?.loggedTimeFrom) query.loggedTimeFrom = query.loggedTimeFrom.replace('T', ' ');
    if (query?.loggedTimeTo) query.loggedTimeTo = query.loggedTimeTo.replace('T', ' ');
    return this.apiService.get<ISearchResponse2<IUASearchResponse>>(`${this.baseURL}/search`, query);
  };
}
